exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-number[data-v-506c3665]{display:inline-block;font-size:.2rem}", ""]);

// exports
